// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bucketCreatorWrapper[data-v-65cefb4c]{width:100%;position:relative;padding:0;background-color:var(--color-white);overflow:hidden}.content .text[data-v-65cefb4c]{color:var(--color-black);font-size:var(--font-size-big);font-weight:400;line-height:20px;margin-bottom:24px}.mobileOnly[data-v-65cefb4c]{display:none}.btnText.thick[data-v-65cefb4c]{font-weight:600}", ""]);
// Exports
module.exports = exports;
